import FooterTwo from "@/components/landing/footer/FooterTwo";
import NavBar from "@/components/landing/navBar/NavBar";
import ScrollToTop from "@/components/landing/scrollToTop/ScrollToTop";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function MarketingLayout() {
  useEffect(() => {
    const root = document.documentElement;
    const { body } = document;
    root.classList.add("marketing-scroll-theme");
    body.classList.add("marketing-scroll-theme");
    return () => {
      root.classList.remove("marketing-scroll-theme");
      body.classList.remove("marketing-scroll-theme");
    };
  }, []);

  return (
    <div className="marketing-site">
      <NavBar />
      <Outlet />
      <FooterTwo />
      <ScrollToTop />
    </div>
  );
}
